<template>
  <div class="layout">
    <header-info activeName="/home"></header-info>
    <div class="content">
      <transition name="move" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
    <footer-info></footer-info>
  </div>
</template>

<script>
import headerInfo from "./header.vue";
import footerInfo from "./footer.vue";
export default {
  components: {
    headerInfo,
    footerInfo
  }
};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  .content {
    flex: 1;
    padding: 0 200px;
    background: #f7f7f7;
    height: calc(100vh - 406px);
  }
}
</style>